<template>

  <div>
    <div
      class="buymodal-block__body">

      <div
        v-if="!moreInfo"
        class="body-form">
        <label
          for="number"
          class="body-form__label">
          Выкуп мобильного устройства по IMEI:
          <!-- <span
            class="circle"
            @click.prevent="moreInfo = true">
            <img
              src="@/../static/img/icons/question.svg">
          </span> -->
        </label>
        <input
          type="text"
          class="body-form__input"
          placeholder="333432000123323"
          minlength="15"
          maxlength="15"
          @input="SET_NUMBER({ number: $event.target.value.toUpperCase(), length: $event.target.value.toString().length})"
          :value="number"
          id="number">
        <div
          class="body-form__size">
          <span
            class="error-mess">
            {{ errorSearch }}
          </span>
          <span
            class="length">
            {{ numberLength }} / 15
          </span>
        </div>
      </div>

      <more-info
        v-else
        :number="number" />

    </div>

    <div
      class="buymodal-block__footer">
      <button
        type="button"
        class="btn next"
        @click.prevent="numberLength==15 ? startSearch() : false">
        Начать выкуп
      </button>
    </div>

  </div>

</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import MoreInfo from './MoreInfo';

export default {
  components: {
    MoreInfo,
  },
  data() {
    return {
      moreInfo: false,
    }
  },
  computed: {
    ...mapState('buyphones', ['number', 'numberLength', 'errorSearch']),
  },
  methods: {
    ...mapMutations('buyphones', ['SET_NUMBER', 'SET_ERROR_SEARCH']),
    ...mapActions('buyphones', ['searchModel']),

    async startSearch() {
      this.SET_ERROR_SEARCH();
      const response = await this.searchModel({ imei: this.number });

    }
  },
}
</script>

<style lang="css">
</style>
